import { Component, OnInit, ViewChild } from '@angular/core';
import { EngagementModel } from '../../../models/engagement.model';
import { environment } from '../../../../environments/environment';
import { EngagementService } from '../../../services/engagement.service';
import { UserService } from './../../../services/user.service';
import { Table } from 'primeng/table';
import moment from 'moment';
import { UserModel } from '../../../models/user.model';
import { MessageService } from 'primeng/api';
import { LanguageConstants } from '../../../shared-components/constant';
import { InfraService } from 'src/app/services/infra.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { severitymessage } from 'src/app/shared-components/constant'; 
import { LanguageHelperService } from 'src/app/services/language.helper.service';
import { AppConfigurationService } from '../../../services/appConfiguration.service';
import { AppConfigurationsModel } from '../../../models/appConfigurations.model';
import { Observable } from 'rxjs';
import { PbiWorkSpaceModel } from '../../../models/pbiWorkSpace.model';
import { PbiWorkSpaceService } from 'src/app/services/pbiworkspace.service';
@Component({
  selector: 'app-engagement',
  templateUrl: './engagement.component.html',
  styleUrls: ['./engagement.component.css']
})
export class EngagementComponent implements OnInit {
  engagements: EngagementModel[];
  isInlineEditable = false;
  isEngagementCreationEnabled: boolean = true;
  isEngagementReadOnly: boolean = false;
  statuses: any[] = [];  
  match: any;
  cols: any[];
  public results: any[] = [];
  isEditable = false;
  public selectedPermissions: any = [];
  private newUserData: UserModel[];
  private EnvName = environment.ENV;
  userEmail: string = "";
  addRemove: string = ""
  private loggedInUPN: string;
  private existingUserData: UserModel[];
  private pbiRegion: any;
  public pbiWorkSpace: PbiWorkSpaceModel = new PbiWorkSpaceModel();
  public model: any = {
    selected: new EngagementModel()
  };
  users: any[] = [];
  america = true;
  restofworld = false;
  public existingAddedUsers: UserModel[];
  public ConfigData: any;
  @ViewChild('dt', { static: true }) private _table: Table;

  public pagerows: number;
  private loggedInId: number;
  private regionName: string;
  private selectedregion: number;
  langCode: string;
  currLangTranslation: any;


  constructor(private infraService: InfraService, private engagementService: EngagementService
    , private userService: UserService, private messageService: MessageService, private appConfigService: AppConfigurationService,
    private pbiworkspaceService: PbiWorkSpaceService,
    private translateService: TranslateService, private languageHelper: LanguageHelperService) {
    this.infraService.infraDetails$.subscribe(data => {
      this.selectedregion = data.InfraId;
      this.regionName = data.RegionName;
    });

    this.isEngagementCreationEnabled = this.appConfigService.GetConfigValueByKey("IsProjectEnabled");
    this.isEngagementReadOnly = this.appConfigService.GetConfigValueByKey("IsProjectsReadOnly");
  }

  ngOnInit() {
    this.isEditable = true;
    this.langCode = localStorage.getItem(LanguageConstants.LANG_CODE);
    this.currLangTranslation = this.translateService.translations[this.langCode];
    this.messageService.clear('myKey1');
    this.pagerows = environment.pageRows25;
    this.translateService.onLangChange.subscribe((langEvent: LangChangeEvent) => {
      this.langCode = langEvent.lang;
      this.currLangTranslation = langEvent.translations;
      this.getMyEngagements();
    });

    this.cols = [
      { field: 'Id', header: 'Id', visible: false, isEditable: false },
      { field: 'PaceId', header: 'Pace ID', visible: false, isEditable: false, width: '6%' },
      { field: 'Status', header: 'Status', visible: true, isEditable: false, width: '5%', styleClass: 'ec-status' },
      { field: 'EngagementName', header: 'Project name', visible: true, isEditable: false, width: '13%', styleClass: 'ec-engagement-name' },
      { field: 'CountryName', header: 'Country', visible: true, isEditable: false, width: '6.5%', styleClass: 'ec-country' },
      { field: 'CountryCode', header: 'Country', visible: false, isEditable: false },
      // tslint:disable-next-line:max-line-length
      { field: 'AccountCalendar', header: 'Accounting calendar', visible: true, isEditable: false, styleClass: 'ec-account-calendar' },
      // tslint:disable-next-line:max-line-length
      { field: 'FiscalYearMonthName', header: 'Fiscal year end', visible: true, isEditable: false, width: '10%', styleClass: 'ec-account-calendar' },
      // tslint:disable-next-line:max-line-length
      { field: 'TemplateName', header: 'Databook template', visible: true, isEditable: false, width: '10%', styleClass: 'ec-account-calendar' },
      // tslint:disable-next-line:max-line-length
      { field: 'ReportingCurrencyName', header: 'Databook currency', visible: true, isEditable: false, width: '10%', styleClass: 'ec-account-calendar' },
      { field: 'Users', header: 'Project team', visible: true, isEditable: false, width: '30%', styleClass: 'ec-engagement-team' },
      { field: 'Edit', header: 'Actions', visible: true, isEditable: false, width: '7%' },
    ];

    this.statuses = [
      { label: 'Active', value: 'Active' },
      { label: 'Inactive', value: 'Inactive' }
    ];

    // this._table.filterConstraints['my'] = (value, filter): boolean => {
    //   // let k = new Date(value);
    //   const k = moment(value, 'DD-MM-YYYY').format('DD-MM-YYYY');
    //   const l = moment(filter, 'DD-MM-YYYY').format('DD-MM-YYYY');
    //   return k === l;
    //   // return k.getTime() == filter.getTime();
    // };

    this.userService.cast.subscribe((userData: UserModel) => {
      if (userData.Id !== undefined) {
        this.loggedInId = userData.Id;
        this.loggedInUPN = userData.UPN;
        this.getMyEngagements();
      }
    });
  }

  private getMyEngagements(): void {
    this.isEditable = true;
    if (this.loggedInId) {
      this.engagementService.getMyEngagements(this.regionName)
        .subscribe((data: EngagementModel[]) => {
          // data = data.filter(x => x.CountryId == this.countryId && x.TemplateId == this.templateId);
          this.engagements = data;
          this.engagements.map((resp) => {
            if (resp.ReportingCurrencyName || resp.FiscalYearMonthName) {
              resp.ReportingCurrencyName = resp.ReportingCurrencyName + ' ' + '(' + resp.CurrencySymbol + ')';
              resp.FiscalYearMonthName = this.languageHelper.convertMonthToLocale(this.langCode, resp.FiscalYearMonthName)
            } 
            else {
              resp.ReportingCurrencyName = '';
            }
          });

        }, error => {
            this.messageService.add({
              key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error
            , summary: this.currLangTranslation.severitymessage.notification, detail: error.error.message, sticky: true, closable: true
          });
        }
        );
    }
  }


  editEngagement(engagement, col): any {
    if (engagement.Status !== false) {
      this.model.selected = Object.assign({}, engagement);
      this.engagementService.getEngagementUsers(engagement.Id).subscribe((userData: UserModel[]) => {
        engagement.UserNames = userData;
        this.existingAddedUsers = userData;
        this.existingUserData = userData;
      });
      engagement.isEditable = true;
    }

    return engagement;

  }

  searchUsers(event) {
    this.userService.getADUsers(event.query).subscribe((data: UserModel[]) => {
      this.results = data;
    }, (error) => { });
  }

  private setWorkSpaceModel(engagement: EngagementModel) {
    console.log('setworkspacemodelenv', environment.ENV)
    console.log('setworkspacemodelenv', this.EnvName.toLowerCase())
    if (this.EnvName.toLowerCase() === 'dev' || this.EnvName.toLowerCase() === 'local' || this.EnvName.toLowerCase() === 'azureeverest') {
      this.EnvName = "Development"
    }
    else if (this.EnvName.toLowerCase() === 'qa') {
      (this.EnvName = 'QA')
    }
    else if (this.EnvName.toLowerCase() === 'prod') {
      (this.EnvName = 'Production')
    }
    else if (this.EnvName.toLowerCase() === 'uat') {
      (this.EnvName = 'UAT')
    }
    if (this.regionName.toUpperCase() === 'US') {
      this.pbiRegion = "eastus"
    }
    else if (this.regionName.toUpperCase() === 'EMEIA') {
      (this.pbiRegion = 'westeurope')
    }
    else if (this.regionName.toUpperCase() === 'APAC') {
      (this.pbiRegion = 'australiaeast')
    }

    this.pbiWorkSpace = {
      environment: this.EnvName,
      location: this.pbiRegion,
      pbiworkspace: true,
      pbiworkspacedestroy: false,
      pbiworkspaceName: "Workspace_Engagement_" + engagement.Id,
      userEmails: this.userEmail,
      Access: 'Contributor',
      addremove: this.addRemove,
      workspaceName: "Workspace_Engagement_" + engagement.Id,
      requestedby: this.loggedInUPN
    };
  }

  updateEngagement(engagement: EngagementModel) {
    this.match = null;
    let i = 0;
    for (i = 0; i < engagement.UserNames.length; i++) {
      const array = engagement.UserNames[i].FullName.split(',');
      if (this.match == null || this.match === undefined) {
        this.match = array.join();
      } else {
        this.match = array.join() + ',' + this.match;
      }
    }

    this.newUserData = engagement.UserNames;
    for (let i = 0; i < this.existingUserData.length; i++) {
      if (i === 0)
        this.userEmail = this.existingUserData[i].UPN;
      else
        this.userEmail = this.userEmail + "," + this.existingUserData[i].UPN;
    }
    // Commenting the triggerint point of PBI
    if (this.newUserData === this.existingUserData) {
    }
    else {
      if (engagement.PowerBIWorkspaceId === 1) {
        this.addRemove = "remove"
        this.setWorkSpaceModel(engagement);
        this.pbiworkspaceService.deleteUser(this.pbiWorkSpace).subscribe(
          (response: any) => {
          });
        for (let i = 0; i < engagement.UserNames.length; i++) {
          if (i === 0)
            this.userEmail = engagement.UserNames[i].UPN
          else
            this.userEmail = this.userEmail + "," + engagement.UserNames[i].UPN;
        }
        this.addRemove = "add"
        this.setWorkSpaceModel(engagement);
        setTimeout(() => { this.pbiworkspaceService.addUser(this.pbiWorkSpace); }, 540000);
      }
    }
    if ((engagement.EngagementName === this.model.selected.EngagementName.trim()) && (engagement.Users.length === this.match.length)) {
      this.match = [];
      this.messageService.add({
        key: this.currLangTranslation.severitymessage.key, severity: severitymessage.info
        , summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.NoChange, sticky: true, closable: true
      });

      return;
    }
    // END
    engagement.ModifiedBy = this.loggedInId;
    engagement.RegionId = this.selectedregion;
    engagement.RegionName = this.regionName;
    engagement.StartDateOfSourceData = moment(engagement.FirstDateOfFiscalYear).format('YYYY-MM-DD');
    this.engagementService.update(engagement).subscribe((response: any) => {
      if (response.message === severitymessage.success) {
        engagement.isEditable = false;
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key, severity: severitymessage.success
          , summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.engagementDetailMessage.SuccessMessage.Updated, sticky: true, closable: true
        });
        this.getMyEngagements();
      } else {
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error,
          summary: this.currLangTranslation.severitymessage.notification, detail: this.currLangTranslation.severitymessage.somethingwrong, sticky: true, closable: true
        });
      }
    },
      error => {
        this.messageService.add({
          key: this.currLangTranslation.severitymessage.key, severity: severitymessage.error
          , summary: this.currLangTranslation.severitymessage.notification, detail: error.error.message, sticky: true, closable: true
        });
      }
    );
  }

  cancelEngagement(engagement) {
    engagement.isEditable = false;
    this.getMyEngagements();
  }

  cancelPreviousEngagements(engagement, col) {
    this.isEditable = true;
    for (let i = 0; i < this.engagements.length; i++) {
      if (engagement.Id === this.engagements[i].Id) {
        this.engagements[i].isEditable = true;
      } else {
        this.engagements[i].isEditable = false;
      }
    }

    this.editEngagement(engagement, col);

  }

  public getCountryFlagClassName(engagement) {
    if (engagement.CountryCode !== undefined && engagement.CountryCode !== null) {
      return 'flag-icon-' + engagement.CountryCode.toLowerCase();
    }
    return '';
  }

  public getClass(data: any) {
    let returnVal = 'ec-default';
    if (data) {
      returnVal = data.styleClass;
    }
    return returnVal;
  }
}
